import { Cart, updateCart as updateCartApi } from "@dana/Overrides/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import { updateContext } from "@insite/client-framework/Context";
import {
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { updateSession } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, ExecuteOnSuccessCallback, LoadCart, UpdateCart, UpdateContext, UpdateSession } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateShipTo";
import { getCookie } from "@insite/mobius/utilities/cookies";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(
    chain,
    UpdateSession,
    async props => {
        const state = props.getState();
        const { cartId } = state.pages.onePageCheckout;
        if (!cartId && props.apiResult) {
            await updateSession({
                session: {
                    billToId: props.parameter.billToId,
                    // shipToId: props.apiResult.id,
                    customerWasUpdated: true,
                },
            });
        }
    }
);

replaceInChain(
    chain,
    LoadCart,
    async props => {
        await makeHandlerChainAwaitable(loadCurrentCart)({ getCartLines: true, getPromotions: false })(
               props.dispatch,
               props.getState,
           );
    }
);

replaceInChain(
    chain,
    UpdateContext,
    props => {
        const state = props.getState();
        const { cartId } = state.pages.onePageCheckout;
        if (!cartId && props.apiResult) {
            updateContext({
                billToId: props.parameter.billToId,  
               // shipToId: props.apiResult.id,             
                settings: getSettingsCollection(props.getState()),
            });
        }
    }
);

replaceInChain(
    chain,
    UpdateCart,
    async props => {
        if (props.apiResult) {
            const state = props.getState() as ApplicationStateDana;
            const cartMode = getCookie('cartMode');
            const { cartId } = state.pages.onePageCheckout;
            let cart: Cart | undefined;
            if (cartMode === 'StockOrderCart') {
                cart = cartId ? getCartState(state, cartId).value! : getCurrentCartState(state).value!;
            } else if (cartMode === 'EmergencyOrderCart') {
                cart = state.emergencyCartState.cart as Cart;
            } else {
                cart = state.annualReturnsCartState.cart as Cart;
            }

            if (!cart) {
                throw new Error("There was no current cart and we are trying to update ship to.");
            }
            await updateCartApi({
                cart: {
                    ...cart,
                    shipToId: props.apiResult.id,
                },
            });
        }
    }
);


replaceInChain(
    chain,
    ExecuteOnSuccessCallback,
    props => {
        const state = props.getState() as ApplicationStateDana;
        const cartMode = getCookie('cartMode');
        const { cartId } = state.pages.onePageCheckout;
        let cart: Cart | undefined;
        if (cartMode === 'StockOrderCart') {
            cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value
        } else if (cartMode === 'EmergencyOrderCart') {
            cart = state.emergencyCartState.cart as Cart;
        } else {
            cart = state.annualReturnsCartState.cart as Cart;
        }
        const hasCartlines = (cart?.cartLines?.length || 0) > 0;
        props.parameter.onSuccess?.(hasCartlines);
    }
);